import { FC } from 'react'

import { useParams } from 'react-router-dom'

import {
  PrimaryScheduleSteps,
  PrimaryScheduleTabs,
} from 'src/Components/PrimaryScheduleTabs'
import { useRedirectFailedCheckout } from 'src/Hooks/useRedirectFailedCheckout'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { ScheduleSteps } from 'src/Types/ui'
import { OrderCheckoutRecoveryModal } from 'src/Pages/Artist/SpotifySchedulePage/OrderCheckoutRecoveryModal'

import { AdsScheduleSettingsPage } from './AdsScheduleSettingsPage'
import { AdsScheduleOrderCheckoutPage } from './AdsScheduleOrderCheckoutPage'
import { SuccessAdsCampaignPaid } from './SuccessAdsCampaignPaid'
import { useScheduleAdsCampaign } from './helpers/useScheduleAdsCampaign'

export const AdsSchedulePage: FC = () => {
  useRedirectFailedCheckout()
  const { number } = useParams()
  useScheduleAdsCampaign()

  const steps: PrimaryScheduleSteps[] = [
    {
      title: 'Campaigns',
      path: ArtistRoutesEnum.CampaignsList,
    },
    {
      title: 'Campaign settings',
      path: `${ArtistRoutesEnum.AdsSchedule}/${number}?step=${ScheduleSteps.SETTINGS}`,
    },

    {
      title: 'Checkout',
      path: `${ArtistRoutesEnum.AdsSchedule}/${number}?step=${ScheduleSteps.CHECKOUT}`,
    },
  ]

  return (
    <>
      <OrderCheckoutRecoveryModal />
      <SuccessAdsCampaignPaid />
      <PrimaryScheduleTabs steps={steps}>
        {/* first must be settings second checkout */}
        <AdsScheduleSettingsPage />
        <AdsScheduleOrderCheckoutPage />
      </PrimaryScheduleTabs>
    </>
  )
}
